module.exports = __webpack_public_path__ + "img/yellow-red-card-symbol.7db2c619.svg";